import { useRouter } from 'found'
import React from 'react'
import { useTranslation } from 'react-i18next'

import ArrowLeft from '../../icons/ArrowLeft'
import { useTypedDispatch, useTypedSelector } from '../../index'
import { resetWagonState } from '../../reducers/wagonSlice'
import { Footer, FooterBackIcon, FooterText } from '../page/PageComponents'

const BottomNavbar = () => {
  const { t } = useTranslation()
  const { router } = useRouter()
  const dispatch = useTypedDispatch()
  const previousTrain = useTypedSelector(
    (state) =>
      (state.found.match.location.state as { previousTrain?: { trainNumber: string } } | null)
        ?.previousTrain
  )

  const handleBackClick = () => {
    if (!previousTrain) {
      dispatch(resetWagonState())
      router.go(-1)
      return
    }

    router.go(-1)
  }

  return (
    <Footer onClick={handleBackClick}>
      <FooterBackIcon>
        <ArrowLeft iconSize="default" />
      </FooterBackIcon>
      <FooterText>
        {previousTrain
          ? t('wagons.backToTrain', { trainNumber: previousTrain.trainNumber })
          : t('wagons.backToSearch')}
      </FooterText>
    </Footer>
  )
}

export default BottomNavbar
